import React, { useEffect, useState } from 'react';
type CountdownProps = {
  compact?: boolean;
  dark?: boolean;
};
function pad(value: number) {
  return String(value).padStart(2, '0');
}
export function Countdown({
  compact = false,
  dark = true
}: CountdownProps) {
  const [seconds, setSeconds] = useState(12 * 3600);
  useEffect(() => {
    const timer = window.setInterval(() => setSeconds(current => Math.max(0, current - 1)), 1000);
    return () => window.clearInterval(timer);
  }, []);
  const parts = [{
    label: 'HOURS',
    value: Math.floor(seconds / 3600)
  }, {
    label: 'MIN',
    value: Math.floor(seconds % 3600 / 60)
  }, {
    label: 'SEC',
    value: seconds % 60
  }];
  if (compact) {
    return <span className="font-semibold tabular-nums" data-id="element-54" data-mp="371zy5pdjq5fv">
        {pad(parts[0].value)} HOURS : {pad(parts[1].value)} MIN : {pad(parts[2].value)} SEC
      </span>;
  }
  return <div className="flex items-start justify-center gap-2 sm:gap-3" aria-live="polite" data-id="element-55" data-mp="15b6a0dphsfw9">
      {parts.map((part, index) => <React.Fragment key={part.label} data-id="element-56" data-mp="y04yk9flrwto" data-mpi={index}>
          <div className={`min-w-[72px] rounded-xl px-3 py-3 text-center sm:min-w-[94px] sm:px-4 ${dark ? 'bg-navy text-white' : 'border border-sage/30 bg-white text-navy'}`} data-id="element-57" data-mp="xz3oa76eved0">
            <div className="text-2xl font-bold tabular-nums sm:text-3xl" data-id="element-58" data-mp="12s50u8j5b1tf">{pad(part.value)}</div>
            <div className={`mt-1 text-[9px] font-bold tracking-[0.18em] ${dark ? 'text-white/60' : 'text-slate'}`} data-id="element-59" data-mp="f22dg5q6ek15">
              {part.label}
            </div>
          </div>
          {index < parts.length - 1 && <span className={`pt-3 font-serif text-2xl ${dark ? 'text-sage-light' : 'text-sage'}`} data-id="element-60" data-mp="o0nv7yntpv0v">
              :
            </span>}
        </React.Fragment>)}
    </div>;
}